var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 100,
    height: 100,
    rx: 30,
    fill: "#808080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3488 28.8438C57.3488 31.7578 57.3488 34.6712 57.3488 37.5853C53.5322 37.4112 50.1116 38.4245 47.0871 40.6258C40.7795 44.3687 37.6123 49.9428 37.5853 57.3486C34.6713 57.3486 31.7578 57.3486 28.8438 57.3486C29.8062 42.639 37.4075 33.3274 51.6478 29.4138C53.5465 29.1815 55.447 28.9917 57.3488 28.8438Z",
    fill: "#F9BC2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3486 28.8438C72.8377 29.9679 82.4024 38.076 86.0438 53.1679C86.2336 54.5561 86.2966 55.9494 86.2339 57.3486C83.3199 57.3486 80.4064 57.3486 77.4924 57.3486C77.5388 55.5503 77.3486 53.7768 76.9223 52.0277C76.6143 50.3984 75.9176 49.0048 74.8317 47.8472C71.0244 41.1245 65.1966 37.7039 57.3486 37.5853C57.3486 34.6712 57.3486 31.7578 57.3486 28.8438Z",
    fill: "#E6453A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8438 57.3496C31.7578 57.3496 34.6713 57.3496 37.5853 57.3496C37.4998 59.1541 37.6899 60.9279 38.1554 62.6706C41.0821 72.1228 47.4797 77.0638 57.3488 77.4932C57.3488 80.4073 57.3488 83.3207 57.3488 86.2347C43.5517 85.2343 34.3034 78.2661 29.604 65.3309C29.1942 62.6872 28.9411 60.0268 28.8438 57.3496Z",
    fill: "#3BA857"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.493 57.3496C80.407 57.3496 83.3205 57.3496 86.2345 57.3496C86.1563 63.1312 84.5726 68.4522 81.4836 73.3125C81.2302 73.6924 81.2302 74.0727 81.4836 74.4526C87.4515 80.3569 93.3426 86.311 99.1568 92.3156C97.0171 94.6461 94.7997 96.9264 92.5056 99.157C86.4193 93.0072 80.2745 86.9261 74.0724 80.9138C69.8567 83.8396 65.1691 85.4866 60.0099 85.8545C59.2497 85.8545 58.4894 85.8545 57.7295 85.8545C57.7295 83.0676 57.7295 80.2801 57.7295 77.4932C69.9459 76.2985 76.5339 69.5839 77.493 57.3496Z",
    fill: "#4789F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3486 77.4922C57.4752 77.4922 57.6023 77.4922 57.7289 77.4922C57.7289 80.2791 57.7289 83.0665 57.7289 85.8534C58.4888 85.8534 59.249 85.8534 60.0093 85.8534C59.2083 86.2213 58.3212 86.3484 57.3486 86.2337C57.3486 83.3197 57.3486 80.4059 57.3486 77.4922Z",
    fill: "#4B96C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8304cee7baed9221de8957f692325bae.svg";
export { ForwardRef as ReactComponent };